var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0652 37.3336H21.6985C21.2318 37.3336 20.5318 37.5669 20.0652 37.8002L11.6652 45.0336C8.39849 47.8336 3.26516 45.0336 3.96516 40.8336C5.36516 32.9002 6.76516 24.9669 7.93183 17.2669C8.63183 12.8336 12.5985 9.56689 17.0318 9.56689H37.5652C41.9985 9.56689 45.9652 12.8336 46.6652 17.2669C48.0652 25.2002 49.4652 33.1336 50.6318 40.8336C51.3318 45.2669 46.1985 48.0669 42.9318 45.0336L34.5318 37.8002C35.2318 37.5669 34.7652 37.3336 34.0652 37.3336Z",
    stroke: "#A33EE8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.999 23.3334H23.3324",
    stroke: "#A33EE8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6657 18.6667V28.0001",
    stroke: "#A33EE8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3322 18.2008C37.0989 18.2008 36.8656 18.4341 36.8656 18.9008C36.8656 19.1341 37.0989 19.3674 37.5656 19.3674C37.7989 19.3674 38.0322 19.1341 38.0322 18.9008C37.7989 18.4341 37.5656 18.2008 37.3322 18.2008",
    stroke: "#A33EE8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9992 22.8673C41.7659 22.8673 41.5326 23.1006 41.5326 23.5673C41.5326 23.8006 41.7659 24.0339 42.2326 24.0339C42.4659 24.0339 42.6992 23.8006 42.6992 23.5673C42.4659 23.1006 42.2326 22.8673 41.9992 22.8673",
    stroke: "#A33EE8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3322 27.534C37.0989 27.534 36.8656 27.7674 36.8656 28.234C36.8656 28.4674 37.0989 28.7007 37.5656 28.7007C37.7989 28.7007 38.0322 28.4674 38.0322 28.234C37.7989 27.7674 37.5656 27.534 37.3322 27.534",
    stroke: "#A33EE8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6652 22.8673C32.4319 22.8673 32.1986 23.1006 32.1986 23.5673C32.1986 23.8006 32.4319 24.0339 32.8986 24.0339C33.1319 24.0339 33.3652 23.8006 33.3652 23.5673C33.1319 23.1006 32.8986 22.8673 32.6652 22.8673",
    stroke: "#A33EE8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/Game.5557105f471421a64b23404271d83930.svg";
export { ForwardRef as ReactComponent };